
function variantSelector(){
    const inputs = window.document.querySelectorAll('.js_variant-selector');

    if (inputs.length < 1) return;

    inputs.forEach(input => {
        if (input.checked) input.classList.add('selected-variant');
        input.addEventListener('click',function(){
            if (this.classList.contains('sold-out')) return;
            this.classList.add('selected-variant');
            inputs.forEach(radio => {
                if (!radio.checked) radio.classList.remove('selected-variant');
            })
        })
    })
}

window.addEventListener('load',variantSelector);